import { Logger } from '@thesavingsgroup/logger/Logger';
import type { Reporter } from '@thesavingsgroup/reporting/types/Reporter';
import type { AxiosRequestConfig } from 'axios';

type ContentfulRequestLoggerDependencies = {
  logger?: Logger;
  reporter: Reporter;
};

export const contentfulRequestLogger =
  ({ reporter, logger = new Logger() }: ContentfulRequestLoggerDependencies) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (request: AxiosRequestConfig<any> | Error): void => {
    logger.info('[REMOTE_CONFIGURATION_REQUEST]', request);

    if (request instanceof Error) {
      reporter.error(
        new Error(`[REMOTE_CONFIGURATION_ERROR] ${request.message}`),
        { originalException: request },
      );
    }
  };
